export default {
    senhaCancelamento: process.env.VUE_APP_SENHACANCELAMENTO
}

